import { useMemo } from 'react'
import styles from './header.module.css'
import { BurgerBtn } from './burgerBtn/burgerBtn'
import { Logo } from './logo/logo'
import { Search } from './search/search'
import { NotificationBtn } from './notificationBtn/notificationBtn'
import { UserProfileHeaderBtn } from './userProfile/userProfileHeaderBtn'
import { SignInBtn } from './signInBtn/signInBtn'
import { useUser } from '../../hooks/context/useUser'

export function Header() {
  const { isLoggedIn } = useUser()

  const authActions = useMemo(
    () =>
      isLoggedIn ? (
        <>
          <NotificationBtn />
          <UserProfileHeaderBtn />
        </>
      ) : (
        <SignInBtn />
      ),
    [isLoggedIn]
  )

  return (
    <header className={styles.header}>
      <BurgerBtn />
      <Logo />
      <Search />
      {authActions}
    </header>
  )
}